import { FC, ReactNode } from 'react'
import { FlexboxGrid } from 'rsuite'

import SearchIconBorder from '../../../Icons/SearchIconBorder'

import styles from '../../../../styles/Search.module.less'

interface SearchMenuItemProps {
  label: string
  highlight?: TrustedHTML
  isHeader?: boolean
  onClick?: () => void
  onKeyDown?: (event: React.KeyboardEvent) => void
}

const SearchMenuItem: FC<SearchMenuItemProps> = ({
  label,
  highlight,
  isHeader = false,
  onClick,
  onKeyDown,
}) => {
  if (isHeader) {
    return (
      <div
        role="option"
        tabIndex={-1}
        aria-selected={false}
      >
        <span className={`rs-auto-complete-item ${styles['search-header']}`}>
          {label}
        </span>
      </div>
    )
  }

  return (
    <div
      role="option"
      tabIndex={-1}
      aria-selected={false}
      data-key={label}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <span className={`rs-auto-complete-item ${highlight ? styles.highlight : ''}`}>
        <FlexboxGrid align="middle">
          <FlexboxGrid.Item className="margin-right-spacer">
            <SearchIconBorder />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item
            className={styles.suggestion}
            dangerouslySetInnerHTML={highlight ? { __html: highlight } : undefined}
          >
            {!highlight ? label : null}
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </span>
    </div>
  )
}

export const SearchMenuItemLabel: FC<{ label: ReactNode }> = ({ label }) => (
  <FlexboxGrid align="middle">
    <FlexboxGrid.Item className="margin-right-spacer">
      <SearchIconBorder />
    </FlexboxGrid.Item>
    <FlexboxGrid.Item>
      {label}
    </FlexboxGrid.Item>
  </FlexboxGrid>
)

export default SearchMenuItem
